export default {
    LOAD_CATEGORYS(state, category) {
        state.items = category;
    }
}